import { useMutation, useQueryClient } from '@tanstack/react-query'
import axios from 'axios'

import { errorToast, successToast } from 'common/components/toastNotification'

import { contentKeys } from '../queryKeys'
import { duplicateContent } from '..'

type DuplicateContentParams = {
  accountId: string
  contentId: string
  name?: string
  includeGeneratedContent?: boolean
  humanControlLines?: {
    elementId: number
    text: string
    sendDate?: string | null
  }[]
}

const useDuplicateContentMutation = () => {
  const queryClient = useQueryClient()

  return useMutation(
    (params: DuplicateContentParams) => duplicateContent(params),
    {
      onError: (error) => {
        const backendMessage = axios.isAxiosError(error)
          ? error.response?.data?.message ?? error.response?.data?.msg
          : undefined

        if (backendMessage) {
          return
        }

        errorToast('Something went wrong. Please try again.')
      },
      onSuccess: () => {
        successToast('Content duplicated successfully.')
      },
      onSettled: () => {
        queryClient.invalidateQueries(contentKeys.contentLibraryAll())
      },
    }
  )
}

export default useDuplicateContentMutation
